import { CLEAR_SNACKBAR, SHOW_SNACKBAR } from './actions';

export const initialState = {
  show: false,
  snackType: 'success',
  snackMessage: '',
  vertical: 'bottom',
  horizontal: 'right',
};

const snackReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SHOW_SNACKBAR:
      return {
        ...state,
        show: true,
        snackType: payload.snackType,
        snackMessage: payload.snackMessage,
        vertical: payload.vertical,
        horizontal: payload.horizontal,
      };
    case CLEAR_SNACKBAR:
      return {
        ...state,
        show: false,
        snackMessage: '',
      };
    default:
      return state;
  }
};

export default snackReducer;
